import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Download, MessageSquareText, SlidersHorizontal } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './HowItWorks.css';

const STEP_ICONS = [MessageSquareText, CheckCircle2, SlidersHorizontal, Download];

const HowItWorks: React.FC = () => {
  const { content } = useI18n();
  const how = content.how;
  return (
    <section className="how-it-works section" aria-label={how.aria}>
      <div className="container">
        <div className="how__steps">
          {how.steps.map((step, index) => {
            const Icon = STEP_ICONS[index];
            const number = String(index + 1).padStart(2, '0');
            return (
              <article key={number} className="how__step">
                <div className="how__step-top">
                  <span className="how__step-number">{number}</span>
                  <span className="how__step-icon"><Icon size={19} strokeWidth={1.7} /></span>
                </div>
                <h2>{step.title}</h2><p>{step.description}</p>
              </article>
            );
          })}
        </div>
        <div className="how__cta">
          <div><h2>{how.ctaTitle}</h2><p>{how.ctaText}</p></div>
          <Link to="/request" className="btn btn-primary">{how.cta}</Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
